/* Home V2: value cards (section 06).
   Two independent responsibilities, both scoped to #pe-value:

   1. 3D flip toggle (original): click toggles aria-pressed, which _value.scss
      reads to rotate .vc-in (hover/focus also flip via CSS). The hidden face is
      pulled from the a11y tree with aria-hidden. Buttons give Enter/Space for
      free, so no keydown handling is needed.

   2. Graph-only replay loop: the designed diagram on each card front lives in a
      .vc-graph container whose reveal (.draw/.pop/.fade) is gated on .vc-graph.in.
      While a graph is on screen its entrance re-runs every 10s — a "snap" reset
      (transitions off -> remove .in -> reflow -> restore) rewinds ONLY the graph,
      so the card's cap/metric/description/flip never re-animate. Reduced motion:
      show the final graph state, no loop. */
(function () {
  'use strict';

  var valueSection = document.getElementById('pe-value');
  if (!valueSection) { return; }

  function $(sel, r) { return (r || document).querySelector(sel); }
  function $$(sel, r) { return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }

  /* 1. flip toggle */
  $$('.vcard', valueSection).forEach(function (card) {
    var front = $('.vc-front', card), back = $('.vc-back', card);
    function apply(on) {
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (front) { front.setAttribute('aria-hidden', on ? 'true' : 'false'); }
      if (back) { back.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    }
    apply(false);
    card.addEventListener('click', function () {
      apply(card.getAttribute('aria-pressed') !== 'true');
    });
  });

  /* 2. graph-only replay loop */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var graphs = $$('.vc-graph', valueSection);

  if (reduce) {
    graphs.forEach(function (g) { g.classList.add('in'); });
    return;
  }

  var HOLD_MS = 10000; // replay each graph's entrance every 10s while on screen

  graphs.forEach(function (g) {
    var timer = null;
    function snap() {                       // rewind just this graph, no transition
      g.classList.add('hv2-snap');
      g.classList.remove('in');
      void g.offsetWidth;                   // flush so the removal takes hold
      g.classList.remove('hv2-snap');
    }
    function start() {
      if (timer !== null) { return; }
      g.classList.add('in');                // first play
      timer = setInterval(function () { snap(); g.classList.add('in'); }, HOLD_MS);
    }
    function stop() {
      if (timer !== null) { clearInterval(timer); timer = null; }
      snap();                               // leave rewound so re-entry plays fresh
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
      }, { threshold: 0.25 });
      io.observe(g);
    } else {
      g.classList.add('in');
    }
  });
})();
